import { Col, Grid, Row, notification } from 'antd';
import bgAuth from 'assets/image/bg-auth.jpg';
import logoPng from 'assets/image/hunt_control_logo.png';
import SignForm from 'components/siginForm';
import React, { useEffect } from 'react';
import * as Api from 'api';
import { useParams } from 'react-router-dom';
import useAuth from 'redux/auth/auth.hook';
import { PATHS } from 'res/routes';
import history from 'redux/history';
import { setProfile } from 'redux/auth/auth.action';
import localStore from 'helpers/localstore';
import classes from './style.module.scss';

const { useBreakpoint } = Grid;

interface ParamTypes {
  token: string,
}
const AuthSignInTokenPage = () => {
  const { md } = useBreakpoint();
  const { token } = useParams<ParamTypes>();
  const { auth } = useAuth();

  console.log('token ==>', token);
  useEffect(() => {
    if (token) {
      // const name = decodeURIComponent(username);
      // const pass = decodeURIComponent(password);
      // signRequestSaga({ username: name, password: pass });

      localStore.setToken(token);
      history.push(PATHS.HOME);
    }
  }, [token]);

  return (
    <Row className={classes.authWrapper}>
      {md && (
        <Col md={8}>
          <div className={classes.leftSide}>
            <img className={classes.authBg} src={bgAuth} alt="" />
            <div className={classes.logoWrapper}>
              <img src={logoPng} alt="" />
              <h1>HuntControl</h1>
            </div>

          </div>
        </Col>
      )}
      <Col md={16} xs={24}>
        <div className={classes.rightpanel}>
          <div className={classes.siginFormWrapper}>
            <h1> Wait for a while</h1>
          </div>
        </div>
        {md && (
          <div className={classes.bottomContact}>
            <div className={classes.divContact}>
              <p>Email is support@huntcontrol.com</p>
              <p>Phone is 225-478-4026 </p>
            </div>
          </div>
        )}
      </Col>
    </Row>
  );
};

export default AuthSignInTokenPage;
